"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _core = require("@material-ui/core");

var _services = require("./services");

var _constants = _interopRequireDefault(require("./constants"));

var EditAttribute =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(EditAttribute, _Component);

  function EditAttribute(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, EditAttribute);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(EditAttribute).call(this, _props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getInitialState", function (props) {
      var attribute = props.attribute,
          quantityConfigOptions = props.quantityConfigOptions;
      var selectedValues = attribute.selectedValues || attribute.defaults || attribute.values;
      selectedValues = (0, _cloneDeep["default"])(selectedValues);
      return {
        selectedValuesHelpText: null,
        inputContainerHelpText: null,
        quantityConfigArray: (0, _cloneDeep["default"])(quantityConfigOptions),
        inputRangeValue: undefined,
        inputListValue: undefined,
        dropDownOptions: _this.createDropdown(selectedValues),
        selectedValues: selectedValues
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reset", function () {
      var state = _this.getInitialState(_this.props);

      _this.setState(state);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createDropdown", function (selectedValues) {
      var attribute = _this.props.attribute;

      if (attribute && !attribute.isRange) {
        var values = (0, _services.filterArray)(attribute.values, selectedValues);
        values = (0, _services.sortByKey)(values);
        return values.map(function (value) {
          return {
            label: value,
            value: value
          };
        });
      }

      return [];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleQuantityConfigChange", function (e, payload) {
      var quantityConfigArray = _this.state.quantityConfigArray;
      var selected = quantityConfigArray.find(function (category) {
        return category.value === payload;
      });
      selected.checked = !selected.checked;

      _this.setState({
        quantityConfigArray: quantityConfigArray
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleInputChange", function (event) {
      var inputValue;

      if (event.target.value) {
        inputValue = parseFloat(event.target.value);
      }

      _this.setState({
        inputRangeValue: inputValue,
        inputContainerStyle: null
      });

      if (inputValue) {
        var inputContainerHelpText = null;
        var inputContainerStyle = 'success';
        var isValid = (0, _services.validateInputForAttribute)(inputValue, _this.props.attribute);
        var selectedValues = _this.state.selectedValues;

        if (selectedValues.find(function (item) {
          return item === inputValue;
        })) {
          inputContainerHelpText = 'Value already selected';
          inputContainerStyle = 'error';
        } else if (isValid) {
          inputContainerHelpText = null;
          inputContainerStyle = 'success';
        } else {
          inputContainerHelpText = 'Enter a valid input';
          inputContainerStyle = 'error';
        }

        _this.setState({
          inputContainerHelpText: inputContainerHelpText,
          inputContainerStyle: inputContainerStyle
        });
      } else {
        _this.setState({
          inputContainerHelpText: null,
          inputContainerStyle: null
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOptionsChange", function (selected) {
      var _this$state = _this.state,
          selectedValues = _this$state.selectedValues,
          dropDownOptions = _this$state.dropDownOptions;
      var optionsHelpText = _this.state.optionsHelpText;
      selectedValues = (0, _cloneDeep["default"])(selectedValues);
      dropDownOptions = (0, _cloneDeep["default"])(dropDownOptions);

      if (selected) {
        if (!selectedValues.find(function (value) {
          return value === selected.label;
        })) {
          selectedValues.push(selected.label);
          dropDownOptions = dropDownOptions.filter(function (item) {
            return item.label !== selected.label;
          });

          _this.setState({
            dropDownOptions: dropDownOptions,
            selectedValues: selectedValues
          });
        } else {
          optionsHelpText = 'Value already selected';
        }
      }

      _this.setState({
        inputListValue: selected,
        optionsHelpText: optionsHelpText
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addChip", function () {
      var selectedValues = _this.state.selectedValues;
      var inputRangeValue = _this.state.inputRangeValue;
      selectedValues = (0, _cloneDeep["default"])(selectedValues);
      selectedValues.push(inputRangeValue);

      _this.setState({
        selectedValues: selectedValues,
        inputContainerHelpText: null,
        inputContainerStyle: null,
        inputRangeValue: undefined
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeChip", function (chip) {
      var _this$state2 = _this.state,
          selectedValuesHelpText = _this$state2.selectedValuesHelpText,
          selectedValues = _this$state2.selectedValues;
      var _this$state3 = _this.state,
          dropDownOptions = _this$state3.dropDownOptions,
          inputRangeValue = _this$state3.inputRangeValue,
          inputListValue = _this$state3.inputListValue;
      var _this$state4 = _this.state,
          inputContainerStyle = _this$state4.inputContainerStyle,
          inputContainerHelpText = _this$state4.inputContainerHelpText,
          optionsHelpText = _this$state4.optionsHelpText;
      var attribute = _this.props.attribute;

      if (selectedValues.length < 2) {
        selectedValuesHelpText = 'Minimum 1 selection is required';

        _this.setState({
          selectedValuesHelpText: selectedValuesHelpText
        });
      } else {
        var index = selectedValues.indexOf(chip);
        selectedValues = (0, _cloneDeep["default"])(selectedValues);
        selectedValues.splice(index, 1);

        if (attribute && !attribute.isRange) {
          dropDownOptions.push({
            label: chip,
            value: chip
          });
          (0, _services.sortByKey)(dropDownOptions, 'label');
        }

        if (chip === inputRangeValue) {
          inputContainerStyle = 'success';
          inputContainerHelpText = null;
        }

        if (inputListValue && chip === inputListValue.value) {
          optionsHelpText = null;
        }

        _this.setState({
          selectedValues: selectedValues,
          dropDownOptions: dropDownOptions,
          inputContainerStyle: inputContainerStyle,
          inputContainerHelpText: inputContainerHelpText,
          optionsHelpText: optionsHelpText
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "saveSelectedValues", function () {
      var _this$state5 = _this.state,
          selectedValues = _this$state5.selectedValues,
          quantityConfigArray = _this$state5.quantityConfigArray;
      var _this$props = _this.props,
          attribute = _this$props.attribute,
          setSelectedValuesInOptions = _this$props.setSelectedValuesInOptions,
          closeModal = _this$props.closeModal,
          saveQuantityConfig = _this$props.saveQuantityConfig;
      closeModal();
      setSelectedValuesInOptions(attribute.label, selectedValues);

      if (attribute.label.toLowerCase() === 'quantity') {
        var quantityConfig = quantityConfigArray.map(function (category) {
          return category.checked;
        });
        saveQuantityConfig(quantityConfig, selectedValues);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "revertAndClose", function () {
      _this.reset();

      _this.props.closeModal();
    });
    _this.state = _this.getInitialState(_props);
    return _this;
  }

  (0, _createClass2["default"])(EditAttribute, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.selectedValues.length < this.state.selectedValues.length) {
        this.setState({
          selectedValues: (0, _services.sortByKey)(this.state.selectedValues),
          inputContainerHelpText: null,
          inputContainerStyle: null,
          inputRangeValue: undefined,
          inputListValue: undefined,
          optionsHelpText: undefined,
          selectedValuesHelpText: null
        });
      }

      if (!(0, _isEqual["default"])(prevState.inputRangeValue, this.state.inputRangeValue)) {
        this.setState({
          selectedValuesHelpText: null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state6 = this.state,
          selectedValues = _this$state6.selectedValues,
          selectedValuesHelpText = _this$state6.selectedValuesHelpText,
          inputRangeValue = _this$state6.inputRangeValue,
          inputContainerStyle = _this$state6.inputContainerStyle,
          inputContainerHelpText = _this$state6.inputContainerHelpText,
          quantityConfigArray = _this$state6.quantityConfigArray,
          optionsHelpText = _this$state6.optionsHelpText,
          inputListValue = _this$state6.inputListValue,
          dropDownOptions = _this$state6.dropDownOptions;
      var _this$props2 = this.props,
          open = _this$props2.open,
          attribute = _this$props2.attribute;
      var label = attribute.label;
      var title = 'Edit ' + label;
      var isQuantity = label.toLowerCase() === 'quantity';
      var disableAddValue = inputContainerStyle === 'error' || !inputRangeValue;
      return _react["default"].createElement(_reactComponents.Modal, {
        className: "modal-quantity-style",
        show: open,
        onRequestHide: this.revertAndClose,
        title: title,
        closeButton: true
      }, _react["default"].createElement("div", {
        className: "quantity-box"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "quantity-input"
      }, _react["default"].createElement("div", {
        className: "range-style"
      }, attribute && attribute.isRange ? _react["default"].createElement(_reactComponents.Tooltip, {
        direction: "right",
        contents: attribute.toolTip
      }, _react["default"].createElement(_reactComponents.TextField, {
        name: "normal",
        label: "Enter Value",
        type: "number",
        step: "1",
        min: "0",
        className: "input-error-box",
        value: inputRangeValue,
        bsStyle: inputContainerStyle || null,
        rightAddon: _react["default"].createElement("button", {
          onClick: function onClick() {
            return _this2.addChip();
          },
          className: "btn btn-default",
          disabled: disableAddValue
        }, "ADD"),
        onChange: this.handleInputChange,
        onKeyDown: function onKeyDown(event) {
          if (event.keyCode === _constants["default"].ENTER_KEY_CODE && !disableAddValue) {
            _this2.addChip();
          }
        },
        helpText: inputContainerHelpText || null
      })) : _react["default"].createElement(_reactComponents.Select, {
        label: "Select Value",
        className: "list-values-style",
        value: inputListValue,
        options: dropDownOptions,
        onChange: this.handleOptionsChange,
        tether: true,
        helpText: optionsHelpText || null
      })), _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "values-box-style quantity-box-style"
      }, selectedValues && selectedValues.map(function (selectedAttributeValue) {
        return _react["default"].createElement(_reactComponents.Tag, {
          value: selectedAttributeValue,
          key: selectedAttributeValue,
          removable: true,
          onRemoveClick: _this2.removeChip
        });
      })), selectedValuesHelpText ? _react["default"].createElement("div", {
        className: "edit-quantity-help-box"
      }, selectedValuesHelpText) : null))), isQuantity ? _react["default"].createElement("div", {
        className: "row quantity-config"
      }, _react["default"].createElement(_core.Divider, null), _react["default"].createElement("div", {
        className: "quantity-config-box"
      }, _react["default"].createElement("span", {
        className: "quantity-selection-header"
      }, "Show selected quantities for :"), _react["default"].createElement("form", null, quantityConfigArray && quantityConfigArray.map(function (config) {
        return _react["default"].createElement(_reactComponents.Checkbox, {
          key: config.value,
          label: config.content,
          checked: config.checked,
          payload: config.value,
          onChange: _this2.handleQuantityConfigChange
        });
      })))) : null), _react["default"].createElement("div", {
        className: "row quantity-footer"
      }, _react["default"].createElement("div", {
        className: "col-md-12"
      }, _react["default"].createElement(_reactComponents.Button, {
        type: "default",
        onClick: this.reset
      }, "Reset"), _react["default"].createElement(_reactComponents.Button, {
        type: "default",
        className: "submit-button-style",
        onClick: this.saveSelectedValues
      }, "Save"))));
    }
  }]);
  return EditAttribute;
}(_react.Component);

exports["default"] = EditAttribute;
(0, _defineProperty2["default"])(EditAttribute, "propTypes", {
  setSelectedValuesInOptions: _propTypes["default"].func,
  attribute: _propTypes["default"].objectOf(_propTypes["default"].any),
  quantityConfigOptions: _propTypes["default"].arrayOf(_propTypes["default"].object),
  closeModal: _propTypes["default"].func,
  saveQuantityConfig: _propTypes["default"].func,
  open: _propTypes["default"].bool
});